const USER_AGENT_UTILS = (() => {
  const BROWSER_MATCHERS = {
    chrome: /chrome|chromium|crios/i,
    firefox: /firefox|fxios/i,
    safari: /safari/i,
    opera: /opr\//i,
    edge: /edg/i,
    internet_explorer: /msie|trident/i,
  };

  /**
   * Attempt to detect the current browser by matching the user agent string.
   * @returns {keyof BROWSER_MATCHERS | undefined} One of `'chrome'`, `'firefox'`, `'safari'`, `'opera'`, `'edge'`,
   * or `'internet_explorer'`, or `undefined` indicating an unknown browser.
   */
  const detectBrowser = () => Object.entries(BROWSER_MATCHERS)
    .find(([, matcher]) => navigator.userAgent.match(matcher))
    ?.[0];

  return {
    detectBrowser,
  };
})();
